import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { AccountPageHttpService } from './../../core/http/internal/accountpage.http.service';
import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
import { DealerHttpService } from '../../core/http/internal/dealer.http.service';
import { ToastrService } from 'ngx-toastr';
import { BecomeDealerTermsModal } from './become-dealer-terms.component';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
    selector: 'become-dealer-form-component',
    template: require('./become-dealer-form.component.html'),
    providers: [AccountPageHttpService],
})

export class BecomeDealerFormComponent implements OnInit, AfterViewInit {

    @ViewChild('formValidationGroup', { static: false }) public formValidationGroup: DxValidationGroupComponent;
    @ViewChild('termsValidationGroup', { static: false }) public termsValidationGroup: DxValidationGroupComponent;

    protected vm: DealerModel = new DealerModel();
    protected messages: any = { };
    protected disableContactInfo = false;

    protected loadIndicatorVisible = false;
    protected submitDisabled = false;

    businessType: any[] = [
        { id: 'Personal', name: 'Частное лицо'},
        { id: 'Company', name: 'Компания'}
    ];

    constructor(
        private readonly accountPageHttpService: AccountPageHttpService,
        private readonly dealerHttpService: DealerHttpService,
        private readonly toastr: ToastrService,
        public ngxSmartModalService: NgxSmartModalService
    ) {

    }

    ngOnInit(): void {
        //do nothing;
        this.loadData();
    }

    ngAfterViewInit() {

    }

    checkComparison() {
        return true;
    }

    private loadData(): void {
        this.accountPageHttpService.getClientInfo().subscribe(response => {
            const info = response.result;
            if (info) {
                this.disableContactInfo = false; //do not disable fields
                this.fillModel(info);
            }
        });
    }

    protected onPhoneCodeChanged(e: any) {
        this.vm.phoneCode = e;
    }

    protected onPhoneChanged(e: any) {
        this.vm.phone = e;
    }

    protected submitClick() {
        const validation = this.formValidationGroup.instance.validate();
        const termsValidation = this.termsValidationGroup.instance.validate();
        if (validation.isValid && termsValidation.isValid) {
            this.loadIndicatorVisible = true;
            this.dealerHttpService.requestToBecome(this.vm).subscribe(r => {
                if (r.success) {
                    this.submitDisabled = true;
                    this.messages.success = ['Ваша заявка принята. Мы свяжемся с вами в ближайшее время.'];
                } else {
                    this.messages.danger = ['Не удалось отправить запрос. Попробуйте позже'];
                }
            }, () => {
                this.messages.danger = ['Не удалось отправить запрос. Попробуйте позже'];
            },
                () => {
                    this.loadIndicatorVisible = false;
                });
        } else {
            if (!termsValidation.isValid) {
                this.toastr.error('Вы должны принять условия договора');
            }
        }
    }

    private fillModel(item: any) {
        this.vm.name = item.firstname + ' ' + item.lastname;
        this.vm.email = item.email;
        this.vm.phone = item.phone;
        this.vm.phoneCode = item.phoneCountryCode;
        this.vm.address = item.addressLine;
        this.vm.city = item.city;
        this.vm.province = item.province;
        this.vm.postal = item.zip;
    }

    openTerms() {
        this.ngxSmartModalService.setModalData({
            result: false
        }, 'modal-become-dealer-terms', true);

        this.ngxSmartModalService.open('modal-become-dealer-terms');
    }
}

class DealerModel {
    public name: string;
    public phone: string;
    public phoneCode: string;
    public email: string;
    public address: string;
    public message: string;
    public acceptTerms = false;
    public city: string;
    public province: string;
    public postal: string;
    public web: string;
    public businessType: string;
    public businessInfo: string;
    public contactInfo: string;
}


// WEBPACK FOOTER //
// ./src/app/become-dealer/components/become-dealer-form.component.ts